import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import { AuthProvider, useAuth } from './contexts/AuthContext'
import { NotificationProvider } from './contexts/NotificationContext'
import { ChatProvider } from './contexts/ChatContext'
import ChatWidget from './components/ChatWidget'
import PrivateRoute from './components/PrivateRoute'
import InviteHandler from './components/InviteHandler'
// ❌ REMOVED: import CommunityView from './components/CommunityView' — replaced by 7-file system
import CommunityHub from './community/CommunityHub'         // ✅ NEW: All community features
import VerifyEmail from './components/Authen/VerifyEmail'
import CommunityJoin from './components/CommunityJoin';

// Public Components
import Landing from './components/Landing'
import SignIn from './components/Authen/SignIn'
import SignUp from './components/Authen/SignUp'
import ForgotPassword from './components/ForgotPassword'
import ResetPassword from './components/ResetPassword'
import Terms from './components/Terms'
import Privacy from './components/Privacy'
import PublicCampaignView from './components/PublicCampaignView'

// Dashboard Components
import Dashboard from './components/Dashboard'
import ProDashboard from './components/ProDashboard'
import Enterprise from './components/Enterprise'

// Other Components
import Editor from './components/Editor'
import PlanSelection from './components/PlanSelection'
import PaymentPage from './components/PaymentPage'
import PaymentSuccess from './components/PaymentSuccess'

const DashboardRouter = () => {
  const { user } = useAuth()
  const userPlan = user?.selectedPlan || user?.plan || 'starter'
  
  switch (userPlan.toLowerCase()) {
    case 'enterprise':
      return <Enterprise />
    case 'pro':
    case 'professional':
    case 'premium':
      return <ProDashboard />
    default:
      return <Dashboard />
  }
}

function App() {
  return (
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <AuthProvider>
        <NotificationProvider>
          <ChatProvider>
            <Toaster
              position="top-right"
              toastOptions={{
                duration: 4000,
                style: { background: '#363636', color: '#fff' },
                success: { duration: 3000, iconTheme: { primary: '#10b981', secondary: '#fff' } },
                error: { duration: 4000, iconTheme: { primary: '#ef4444', secondary: '#fff' } }
              }}
            />

            <Routes>
              {/* ─── Public Routes ─────────────────────── */}
              <Route path="/" element={<Landing />} />
              <Route path="/signin" element={<SignIn />} />
              <Route path="/signup" element={<SignUp />} />
              <Route path="/invite/:token" element={<InviteHandler />} />
              <Route path="/share/:shareToken" element={<PublicCampaignView />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/verify-email" element={<VerifyEmail />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/community/join/:communityId" element={<CommunityJoin />} />

              {/* ─── Payment Routes ───────────────────── */}
              <Route path="/plan-selection" element={<PlanSelection />} />
              <Route path="/payment" element={<PaymentPage />} />
              <Route path="/payment-success" element={<PaymentSuccess />} />

              {/* ─── Protected Routes ──────────────────── */}
              <Route path="/dashboard" element={<PrivateRoute><DashboardRouter /></PrivateRoute>} />
              <Route path="/editor/:campaignId?" element={<PrivateRoute><Editor /></PrivateRoute>} />
              
              {/* ─── Community Hub (All community features) ─ */}
              <Route 
                path="/community/join/:communityId" 
                element={<CommunityHub />} 
              />
              <Route 
                path="/community" 
                element={
                  <PrivateRoute>
                    <CommunityHub />
                  </PrivateRoute>
                } 
              />
              <Route 
                path="/community/:communityId" 
                element={
                  <PrivateRoute>
                    <CommunityHub />
                  </PrivateRoute>
                } 
              />

              {/* ─── Catch-all ─────────────────────────── */}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>

            <ChatWidget />
          </ChatProvider>
        </NotificationProvider>
      </AuthProvider>
    </Router>
  )
}

export default App 